module.exports = __webpack_public_path__ + "static/icons/icon-map--uk-6a5375f446bbb389a0476bcd986efcb0.svg";